import SimpleModal from "app/components/Modals/SimpleModal";
import { useAppSelector } from "utils/redux/hooks";
import {
  selectAllCompanyUsersById,
  selectSampleUsersInfoById,
} from "app/containers/Global/slice";
import { CelebrateOrSupportType } from "../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPartyHorn } from "@fortawesome/pro-solid-svg-icons";
import { faHandshakeAngle } from "@fortawesome/pro-regular-svg-icons";
import { getScoreSpan } from "../helpers";
import { Card } from "react-bootstrap";
import useModalContent from "utils/hooks/useModalContent";
import { selectWeeklyCheckInCompanySettings } from "../slice";

interface Props {
  celebrationOrSupportItem: CelebrateOrSupportType | null;
  isSupport?: boolean;
  onClose: () => void;
  isSample?: boolean;
}

const CelebrateAndSupportFollowUpModal = ({
  onClose,
  celebrationOrSupportItem,
  isSupport,
  isSample,
}: Readonly<Props>) => {
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const sampleUsersById = useAppSelector(selectSampleUsersInfoById);
  const users = isSample ? sampleUsersById : usersById;
  const frozenIsSupport = useModalContent(
    isSupport,
    !!celebrationOrSupportItem
  );
  const frozenCelebrationOrSupportItem = useModalContent(
    celebrationOrSupportItem,
    !!celebrationOrSupportItem
  );
  const weeklyCheckInCompanySettings = useAppSelector(
    selectWeeklyCheckInCompanySettings
  );
  const hideScore = useModalContent(
    weeklyCheckInCompanySettings?.visibilityMode !== "open",
    !!celebrationOrSupportItem
  );

  const getTitle = () => {
    if (!frozenCelebrationOrSupportItem) {
      return "";
    }
    const user = users[frozenCelebrationOrSupportItem.userAccountId];
    const usersName = user?.firstName ?? "User";
    if (frozenIsSupport) {
      return `Follow Up with ${usersName}`;
    }
    return `Send Recognition to ${usersName}`;
  };

  const getCelebrateBody = () => (
    <div className="weekly-checkin-follow-up-modal-body">
      <div>
        <p className="spotlight-title">
          <b>Win Spotlight:</b>
        </p>
        <ul className="list-disc">
          <li>
            <b>Achievement:</b>{" "}
            {frozenCelebrationOrSupportItem?.winSpotlight?.achievement}
          </li>
          <li>
            <b>Impact:</b>{" "}
            {frozenCelebrationOrSupportItem?.winSpotlight?.impact}
          </li>
        </ul>
        <div className="score-container">
          {!hideScore &&
            getScoreSpan(
              "Magnitude",
              frozenCelebrationOrSupportItem?.winSpotlight?.magnitude,
              {
                appendScoreText: " out of 10",
              }
            )}
        </div>
      </div>
      <Card className="call-to-action-container">
        <FontAwesomeIcon icon={faPartyHorn} className="icon" />
        <div className="column-gap-4px">
          <p>
            <b>Recognition</b>
          </p>
          <p>{frozenCelebrationOrSupportItem?.winSpotlight?.recognition}</p>
        </div>
      </Card>
    </div>
  );

  const getSupportBody = () => (
    <div className="weekly-checkin-follow-up-modal-body">
      <div>
        <p className="spotlight-title">
          <b>Issue Spotlight:</b>
        </p>
        <ul className="list-disc">
          <li>
            <b>Issue:</b>{" "}
            {frozenCelebrationOrSupportItem?.issueSpotlight?.issue}
          </li>
          <li>
            <b>Impact:</b>{" "}
            {frozenCelebrationOrSupportItem?.issueSpotlight?.impact}
          </li>
        </ul>
        <div className="score-container">
          {!hideScore &&
            getScoreSpan(
              "Severity",
              frozenCelebrationOrSupportItem?.issueSpotlight?.severity,
              {
                appendScoreText: " out of 10",
                isInverted: true,
              }
            )}
        </div>
      </div>
      <Card className="call-to-action-container">
        <FontAwesomeIcon icon={faHandshakeAngle} className="icon" />
        <div className="column-gap-4px">
          <p>
            <b>Action</b>
          </p>
          <p>{frozenCelebrationOrSupportItem?.issueSpotlight?.action}</p>
        </div>
      </Card>
    </div>
  );

  return (
    <SimpleModal
      onHide={onClose}
      show={!!celebrationOrSupportItem}
      title={getTitle()}
    >
      <hr className="m-0" />
      {frozenIsSupport ? getSupportBody() : getCelebrateBody()}
    </SimpleModal>
  );
};

export default CelebrateAndSupportFollowUpModal;
